import { Injectable } from '@angular/core';
import { StoreConfig, Store } from '@datorama/akita';
import { MemberLoyaltyStatus } from './member-loyalty-status.model';

function createInitialState() {
  return {} as MemberLoyaltyStatus;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'member-loyalty-status' })
export class MemberLoyaltyStatusStore extends Store<MemberLoyaltyStatus> {
  constructor() {
    super(createInitialState());
  }
}